export default function (campaign) {
  const {
    brands,
    ccdbReportEnabled,
    ccdbReportType,
    config,
    description,
    endDate,
    finality,
    manager,
    marketCodes,
    masterKey,
    name,
    onlyHeader,
    recordType,
    segmentType,
    startDate,
    status,
    type
  } = campaign

  return {
    brands,
    ccdbReportEnabled,
    ccdbReportType,
    config,
    description,
    endDate: endDate || null,
    finality,
    manager,
    marketCodes: Array.isArray(marketCodes) ? marketCodes : [marketCodes],
    masterKey,
    name,
    onlyHeader,
    recordType,
    segmentType,
    startDate: startDate || null,
    status,
    type
  }
}
